<div class="wrapper--spacing-horizontal print-only">
  <div class="avoid-page-break" *ngrxLet="customer$ as customer">
    @if (customer) {
      <agr-value-row [label]="reportForLabel | translate" class="customer">{{
        customer.name
      }}</agr-value-row>
      <agr-value-row [label]="'address' | translate"
        >{{ customer.street }} {{ customer.houseNumber }}
        {{ customer.houseNumberAddition }}
      </agr-value-row>
      <agr-value-row [label]="'city' | translate"
        >{{ customer.postalCode }} {{ customer.city }}
      </agr-value-row>
      <agr-value-row [label]="'mobile' | translate">{{ customer.mobileNumber }}</agr-value-row>
      <agr-value-row [label]="'telephone' | translate">{{ customer.phoneNumber }}</agr-value-row>
      <agr-value-row [label]="'email' | translate">{{ customer.emailAddress }}</agr-value-row>
      <agr-value-row [label]="'customerNumber' | translate">{{
        customer.externalId
      }}</agr-value-row>
    }
  </div>
  <div class="avoid-page-break" *ngrxLet="loggedInEmployee$ as loggedInEmployee">
    <h2 class="text--h5">{{ 'contactTitle' | translate }}</h2>
    @if (loggedInEmployee) {
      <agr-value-row [label]="'adviser' | translate"
        >{{ loggedInEmployee.lastName }}, {{ loggedInEmployee.firstName }}</agr-value-row
      >
      <agr-value-row [label]="'mobile' | translate">
        {{ loggedInEmployee.mobilePhoneNumber }}
      </agr-value-row>
      <agr-value-row [label]="'email' | translate">
        {{ loggedInEmployee.emailAddress }}
      </agr-value-row>
    }
  </div>
</div>
